/**
 * com.remedirx.apps.MyRemedi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AggregateData } from '../model/aggregateData';
import { MedicationSummaryMedPassSummaryDetail } from '../model/medicationSummaryMedPassSummaryDetail';
import { MedicationSummaryOrderSummaryDetail } from '../model/medicationSummaryOrderSummaryDetail';
import { NursingStation } from '../model/nursingStation';
import { ResidentCountResult } from '../model/residentCountResult';
import { SortFilterDto } from '../model/sortFilterDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class OrderSummaryService {

    protected basePath = 'http://localhost:3402';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Average number of med passes per day by nursing station (cart).
     * This should be used only when a single org unit is selected in the UI.  Results will be grouped by Nursing Station and get the average # of medpasses for the Nursing Station  4 unique nursing station and rest is grouped to \&quot;others\&quot;                    Sample Call      http://URL/api/OrderSummary/GetAverageMedPassPerDayByCart?orgUnit&#x3D;590
     * @param orgUnit Organizational Unit to return data for, should be a single facility and should not contain a region
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderSummaryGetAverageMedPassPerDayByCart(orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public orderSummaryGetAverageMedPassPerDayByCart(orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public orderSummaryGetAverageMedPassPerDayByCart(orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public orderSummaryGetAverageMedPassPerDayByCart(orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderSummaryGetAverageMedPassPerDayByCart.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<AggregateData>>(`${this.basePath}/api/OrderSummary/GetAverageMedPassPerDayByCart`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Average number of med passes per resident by nursing station (cart).
     * This should be used only when a single org unit is selected in the UI.  Results will be grouped by Nursing Station and get the average # of medpasses all the residents in  the given nursing station  4 unique nursing station and rest is grouped to \&quot;others\&quot;                    Sample Call      http://URL/api/OrderSummary/GetAverageMedPassPerResidentByCart?orgUnit&#x3D;590
     * @param orgUnit Organizational Unit to return data for, should be a single facility and should not contain a region
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderSummaryGetAverageMedPassPerResidentByCart(orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public orderSummaryGetAverageMedPassPerResidentByCart(orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public orderSummaryGetAverageMedPassPerResidentByCart(orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public orderSummaryGetAverageMedPassPerResidentByCart(orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderSummaryGetAverageMedPassPerResidentByCart.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<AggregateData>>(`${this.basePath}/api/OrderSummary/GetAverageMedPassPerResidentByCart`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Average Orders
     * Displays average number of orders broken into RX/OTC                    Sample Call      http://URL/api/OrderSummary/GetAverageOrders?orgUnit&#x3D;10wilm
     * @param orgUnit Organizational Unit to return data for, should be a single facility and should not contain a region
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderSummaryGetAverageOrders(orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<ResidentCountResult>;
    public orderSummaryGetAverageOrders(orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResidentCountResult>>;
    public orderSummaryGetAverageOrders(orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResidentCountResult>>;
    public orderSummaryGetAverageOrders(orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderSummaryGetAverageOrders.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ResidentCountResult>(`${this.basePath}/api/OrderSummary/GetAverageOrders`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Average Orders per Month over the past 6 months
     * Data in this call is aggregated.                    Sample Call      http://URL/api/OrderSummary/GetAverageOrdersByMonth?startDate&#x3D;2016-1-1T12:30:00&amp;amp;endDate&#x3D;2017-2-1T12:30:00&amp;amp;orgUnit&#x3D;10wilm
     * @param orgUnit Organizational Unit to return data for, should be a single facility and should not contain a region
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderSummaryGetAverageOrdersByMonth(orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public orderSummaryGetAverageOrdersByMonth(orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public orderSummaryGetAverageOrdersByMonth(orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public orderSummaryGetAverageOrdersByMonth(orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderSummaryGetAverageOrdersByMonth.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/OrderSummary/GetAverageOrdersByMonth`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Average Orders by Primary Prescriber
     * Displays average number of orders broken into Primary Prescriber and RX/OTC                    Sample Call      http://URL/api/OrderSummary/GetAverageRoutineOrders?orgUnit&#x3D;10wilm
     * @param orgUnit Organizational Unit to return data for, should be a single facility and should not contain a region
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderSummaryGetAverageOrdersByPrescriber(orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public orderSummaryGetAverageOrdersByPrescriber(orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public orderSummaryGetAverageOrdersByPrescriber(orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public orderSummaryGetAverageOrdersByPrescriber(orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderSummaryGetAverageOrdersByPrescriber.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<AggregateData>>(`${this.basePath}/api/OrderSummary/GetAverageOrdersByPrescriber`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Average PRN Orders by Primary Prescriber per resident
     * The list will show a one to one mapping of each resident to a specific medication                    Sample Call      http://URL/api/OrderSummary/GetAveragePRNOrdersByPrescriber?startDate&#x3D;2016-1-1T12:30:00&amp;amp;endDate&#x3D;2017-2-1T12:30:00&amp;amp;orgUnit&#x3D;10wilm
     * @param orgUnit Organizational Unit to return data for, should be a single facility and should not contain a region
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderSummaryGetAveragePRNOrdersByPrescriber(orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public orderSummaryGetAveragePRNOrdersByPrescriber(orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public orderSummaryGetAveragePRNOrdersByPrescriber(orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public orderSummaryGetAveragePRNOrdersByPrescriber(orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderSummaryGetAveragePRNOrdersByPrescriber.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<AggregateData>>(`${this.basePath}/api/OrderSummary/GetAveragePRNOrdersByPrescriber`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Average Prn Orders per month over the past 6 months
     * Data in this call is aggregated.                    Sample Call      http://URL/api/OrderSummary/GetAveragePrnOrdersByMonth?startDate&#x3D;2016-1-1T12:30:00&amp;amp;endDate&#x3D;2017-2-1T12:30:00&amp;amp;orgUnit&#x3D;10wilm
     * @param orgUnit Organizational Unit to return data for, should be a single facility and should not contain a region
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderSummaryGetAveragePrnOrdersByMonth(orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public orderSummaryGetAveragePrnOrdersByMonth(orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public orderSummaryGetAveragePrnOrdersByMonth(orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public orderSummaryGetAveragePrnOrdersByMonth(orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderSummaryGetAveragePrnOrdersByMonth.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/OrderSummary/GetAveragePrnOrdersByMonth`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PRN orders by Rx Group  (category).
     * Displays drugs divided into Rx and OTC, with an average medications per resident value.                    Sample Call      http://URL/api/OrderSummary/GetAveragePrnOrdersByRxOtc?startDate&#x3D;2016-1-1T12:30:00&amp;amp;endDate&#x3D;2017-2-1T12:30:00&amp;amp;orgUnit&#x3D;10wilm
     * @param orgUnit Organizational Unit to return data for, should be a single facility and should not contain a region
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderSummaryGetAveragePrnOrdersByRxOtc(orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<ResidentCountResult>;
    public orderSummaryGetAveragePrnOrdersByRxOtc(orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResidentCountResult>>;
    public orderSummaryGetAveragePrnOrdersByRxOtc(orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResidentCountResult>>;
    public orderSummaryGetAveragePrnOrdersByRxOtc(orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderSummaryGetAveragePrnOrdersByRxOtc.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ResidentCountResult>(`${this.basePath}/api/OrderSummary/GetAveragePrnOrdersByRxOtc`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Average Routine Orders
     * Displays average number of Routine orders broken into RX/OTC                    Sample Call      http://URL/api/OrderSummary/GetAverageRoutineOrders?startDate&#x3D;2016-1-1T12:30:00&amp;amp;endDate&#x3D;2017-2-1T12:30:00&amp;amp;orgUnit&#x3D;10wilm
     * @param orgUnit Organizational Unit to return data for, should be a single facility and should not contain a region
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderSummaryGetAverageRoutineOrders(orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<ResidentCountResult>;
    public orderSummaryGetAverageRoutineOrders(orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResidentCountResult>>;
    public orderSummaryGetAverageRoutineOrders(orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResidentCountResult>>;
    public orderSummaryGetAverageRoutineOrders(orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderSummaryGetAverageRoutineOrders.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ResidentCountResult>(`${this.basePath}/api/OrderSummary/GetAverageRoutineOrders`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Average Routine Orders per month over the past 6 months
     * Data in this call is aggregated.                    Sample Call      http://URL/api/OrderSummary/GetAverageRoutineOrdersByMonth?startDate&#x3D;2016-1-1T12:30:00&amp;amp;endDate&#x3D;2017-2-1T12:30:00&amp;amp;orgUnit&#x3D;10wilm
     * @param orgUnit Organizational Unit to return data for, should be a single facility and should not contain a region
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderSummaryGetAverageRoutineOrdersByMonth(orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public orderSummaryGetAverageRoutineOrdersByMonth(orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public orderSummaryGetAverageRoutineOrdersByMonth(orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public orderSummaryGetAverageRoutineOrdersByMonth(orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderSummaryGetAverageRoutineOrdersByMonth.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/OrderSummary/GetAverageRoutineOrdersByMonth`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Average Routine Orders by Primary Prescriber
     * Displays average number of orders broken into Primary Prescriber and RX/OTC                    Sample Call      http://URL/api/OrderSummary/GetAverageRoutineOrdersByPrescriber?startDate&#x3D;2016-1-1T12:30:00&amp;amp;endDate&#x3D;2017-2-1T12:30:00&amp;amp;orgUnit&#x3D;10wilm
     * @param orgUnit Organizational Unit to return data for, should be a single facility and should not contain a region
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderSummaryGetAverageRoutineOrdersByPrescriber(orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public orderSummaryGetAverageRoutineOrdersByPrescriber(orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public orderSummaryGetAverageRoutineOrdersByPrescriber(orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public orderSummaryGetAverageRoutineOrdersByPrescriber(orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderSummaryGetAverageRoutineOrdersByPrescriber.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<AggregateData>>(`${this.basePath}/api/OrderSummary/GetAverageRoutineOrdersByPrescriber`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Raw data for Black Box (Grid Data).
     * Data in this call is not aggregated.                    Sample Call      http://URL/api/OrderSummary/GetBlackBoxOrders?startDate&#x3D;2016-1-1T12:30:00&amp;amp;endDate&#x3D;2017-2-1T12:30:00&amp;amp;orgUnit&#x3D;10wilm
     * @param orgUnit Organizational Unit to return data for, should be a single facility and should not contain a region
     * @param sortFilterDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderSummaryGetBlackBoxOrders(orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryOrderSummaryDetail>;
    public orderSummaryGetBlackBoxOrders(orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryOrderSummaryDetail>>;
    public orderSummaryGetBlackBoxOrders(orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryOrderSummaryDetail>>;
    public orderSummaryGetBlackBoxOrders(orgUnit: string, sortFilterDto: SortFilterDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderSummaryGetBlackBoxOrders.');
        }

        if (sortFilterDto === null || sortFilterDto === undefined) {
            throw new Error('Required parameter sortFilterDto was null or undefined when calling orderSummaryGetBlackBoxOrders.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryOrderSummaryDetail>(`${this.basePath}/api/OrderSummary/GetBlackBoxOrders`,
            sortFilterDto,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Black Box data aggregated by drug groups up to a maximum of 6 (including other)
     * Sample Call  http://URL/api/OrderSummary/GetBlackBoxOrdersByDrugGroup?orgUnit&#x3D;10wilm
     * @param orgUnit Organizational Unit to return data for, should be a single facility and should not contain a region
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderSummaryGetBlackBoxOrdersByDrugGroup(orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<AggregateData>;
    public orderSummaryGetBlackBoxOrdersByDrugGroup(orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AggregateData>>;
    public orderSummaryGetBlackBoxOrdersByDrugGroup(orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AggregateData>>;
    public orderSummaryGetBlackBoxOrdersByDrugGroup(orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderSummaryGetBlackBoxOrdersByDrugGroup.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/hal+json',
            'application/hal+xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<AggregateData>(`${this.basePath}/api/OrderSummary/GetBlackBoxOrdersByDrugGroup`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Black Box data aggregated by prescriber up to a maximum of 6 (including other)
     * Sample Call  http://URL/api/OrderSummary/GetBlackBoxOrdersByPrescriber?orgUnit&#x3D;10wilm
     * @param orgUnit Organizational Unit to return data for, should be a single facility and should not contain a region
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderSummaryGetBlackBoxOrdersByPrescriber(orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<AggregateData>;
    public orderSummaryGetBlackBoxOrdersByPrescriber(orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AggregateData>>;
    public orderSummaryGetBlackBoxOrdersByPrescriber(orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AggregateData>>;
    public orderSummaryGetBlackBoxOrdersByPrescriber(orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderSummaryGetBlackBoxOrdersByPrescriber.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/hal+json',
            'application/hal+xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<AggregateData>(`${this.basePath}/api/OrderSummary/GetBlackBoxOrdersByPrescriber`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Raw data for Med Pass detail for a given facility.  This table displays medpasses for all the active orders till date
     * Data in this call is not aggregated.                    Sample Call      http://URL/api/OrderSummary/GetMedPasSummaryDetails?orgUnit&#x3D;10wilm
     * @param orgUnit Organizational Unit to return data for, should be a single facility and should not contain a region
     * @param sortFilterDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderSummaryGetMedPasSummaryDetails(orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryMedPassSummaryDetail>;
    public orderSummaryGetMedPasSummaryDetails(orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryMedPassSummaryDetail>>;
    public orderSummaryGetMedPasSummaryDetails(orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryMedPassSummaryDetail>>;
    public orderSummaryGetMedPasSummaryDetails(orgUnit: string, sortFilterDto: SortFilterDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderSummaryGetMedPasSummaryDetails.');
        }

        if (sortFilterDto === null || sortFilterDto === undefined) {
            throw new Error('Required parameter sortFilterDto was null or undefined when calling orderSummaryGetMedPasSummaryDetails.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryMedPassSummaryDetail>(`${this.basePath}/api/OrderSummary/GetMedPasSummaryDetails`,
            sortFilterDto,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * MedPass for a nursing station group selected in dropdown.
     * This should be used only when a single org unit is selected in the UI.  Results will be grouped by Nursing Station(cart) and get the MedPass times for all the hour   of the day.  4 unique nursing station and rest is grouped to \&quot;other nursing station\&quot;                    Sample Call      http://URL/api/OrderSummary/GetMedPassTimePerNursingStationGroup?orgUnit&#x3D;590
     * @param orgUnit Organizational Unit to return data for, should be a single facility and should not contain a region
     * @param nursingStation Nursing Station from framework.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderSummaryGetMedPassTimePerNursingStationGroup(orgUnit: string, nursingStation: NursingStation, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public orderSummaryGetMedPassTimePerNursingStationGroup(orgUnit: string, nursingStation: NursingStation, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public orderSummaryGetMedPassTimePerNursingStationGroup(orgUnit: string, nursingStation: NursingStation, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public orderSummaryGetMedPassTimePerNursingStationGroup(orgUnit: string, nursingStation: NursingStation, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderSummaryGetMedPassTimePerNursingStationGroup.');
        }

        if (nursingStation === null || nursingStation === undefined) {
            throw new Error('Required parameter nursingStation was null or undefined when calling orderSummaryGetMedPassTimePerNursingStationGroup.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded',
            'application/hal+json',
            'application/hal+xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/OrderSummary/GetMedPassTimePerNursingStationGroup`,
            nursingStation,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * This gives an area chart for Med Pass timesby nursing station (cart).
     * This should be used only when a single org unit is selected in the UI.  And only be used if there is only one nursing station (cart) selected in UI dropdown  Results will be grouped by adminTimes                      Sample Call      http://URL/api/OrderSummary/GetMedPassTimesPerNursingStation?nsId&#x3D;LTC&amp;amp;orgUnit&#x3D;590
     * @param nsId nsId is the nursing stastion Id that is selected from the dropdown
     * @param orgUnit Organizational Unit to return data for, should be a single facility and should not contain a region
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderSummaryGetMedPassTimesPerNursingStation(nsId: string, orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public orderSummaryGetMedPassTimesPerNursingStation(nsId: string, orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public orderSummaryGetMedPassTimesPerNursingStation(nsId: string, orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public orderSummaryGetMedPassTimesPerNursingStation(nsId: string, orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (nsId === null || nsId === undefined) {
            throw new Error('Required parameter nsId was null or undefined when calling orderSummaryGetMedPassTimesPerNursingStation.');
        }

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderSummaryGetMedPassTimesPerNursingStation.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (nsId !== undefined && nsId !== null) {
            queryParameters = queryParameters.set('nsId', <any>nsId);
        }
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<AggregateData>>(`${this.basePath}/api/OrderSummary/GetMedPassTimesPerNursingStation`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * This gets the list of Nursing Station for a given facility.
     * This should be used only when a single org unit is selected in the UI.         Sample Call      http://URL/api/OrderSummary/GetNursingStationForFacility?orgUnit&#x3D;590
     * @param orgUnit Organizational Unit to return data for, should be a single facility and should not contain a region
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderSummaryGetNursingStationForFacility(orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<Array<NursingStation>>;
    public orderSummaryGetNursingStationForFacility(orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<NursingStation>>>;
    public orderSummaryGetNursingStationForFacility(orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<NursingStation>>>;
    public orderSummaryGetNursingStationForFacility(orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderSummaryGetNursingStationForFacility.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<NursingStation>>(`${this.basePath}/api/OrderSummary/GetNursingStationForFacility`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * This gets the list of Nursing Station group for a given facility.
     * This should be used only when a single org unit is selected in the UI.         Sample Call      http://URL/api/OrderSummary/GetNursingStationGroupsForFacility?orgUnit&#x3D;590
     * @param orgUnit Organizational Unit to return data for, should be a single facility and should not contain a region
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderSummaryGetNursingStationGroupsForFacility(orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<Array<NursingStation>>;
    public orderSummaryGetNursingStationGroupsForFacility(orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<NursingStation>>>;
    public orderSummaryGetNursingStationGroupsForFacility(orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<NursingStation>>>;
    public orderSummaryGetNursingStationGroupsForFacility(orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderSummaryGetNursingStationGroupsForFacility.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<NursingStation>>(`${this.basePath}/api/OrderSummary/GetNursingStationGroupsForFacility`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns raw data for the PRN Orders over 60 Days grid. the data is not aggregated.
     * Data in this call is not aggregated.      Sample Call      http://URL/api/OrderSummary/GetOrderSummaryPrnOverSixtyDays?orgUnit&#x3D;10wilm
     * @param orgUnit List of OrgUnits to return data for, should be facilities list and should not contain a region
     * @param sortFilterDto Dto used to communicate sorting, filtering and paging
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderSummaryGetOrderSummaryPrnOverSixtyDays(orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryOrderSummaryDetail>;
    public orderSummaryGetOrderSummaryPrnOverSixtyDays(orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryOrderSummaryDetail>>;
    public orderSummaryGetOrderSummaryPrnOverSixtyDays(orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryOrderSummaryDetail>>;
    public orderSummaryGetOrderSummaryPrnOverSixtyDays(orgUnit: string, sortFilterDto: SortFilterDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderSummaryGetOrderSummaryPrnOverSixtyDays.');
        }

        if (sortFilterDto === null || sortFilterDto === undefined) {
            throw new Error('Required parameter sortFilterDto was null or undefined when calling orderSummaryGetOrderSummaryPrnOverSixtyDays.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryOrderSummaryDetail>(`${this.basePath}/api/OrderSummary/GetOrderSummaryPrnOverSixtyDays`,
            sortFilterDto,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Order Summary medication groups, top 4 with the fifth group being \&quot;other\&quot;
     * Displays top 4 drug groups with the fifth group being \&quot;other\&quot;      Sample Call      http://URL/api/OrderSummary/GetOrderSummaryPrnOverSixtyDaysByDrugGroup?orgUnit&#x3D;10wilm
     * @param orgList List of OrgUnits to return data for, should be facilities list and should not contain a region
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderSummaryGetOrderSummaryPrnOverSixtyDaysByDrugGroup(orgList: string, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public orderSummaryGetOrderSummaryPrnOverSixtyDaysByDrugGroup(orgList: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public orderSummaryGetOrderSummaryPrnOverSixtyDaysByDrugGroup(orgList: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public orderSummaryGetOrderSummaryPrnOverSixtyDaysByDrugGroup(orgList: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgList === null || orgList === undefined) {
            throw new Error('Required parameter orgList was null or undefined when calling orderSummaryGetOrderSummaryPrnOverSixtyDaysByDrugGroup.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgList !== undefined && orgList !== null) {
            queryParameters = queryParameters.set('orgList', <any>orgList);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<AggregateData>>(`${this.basePath}/api/OrderSummary/GetOrderSummaryPrnOverSixtyDaysByDrugGroup`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Order Summary medication  grouped by prescriber
     * Queries Order Summary  medications and returns groupings by Prescriber and then by drug group.  Count of each group is stored in ItemCount      Sample Call      http://URL/api/OrderSummary/GetOrderSummaryPrnOverSixtyDaysByPrescriber?orgUnit&#x3D;10wilm
     * @param orgUnit List of OrgUnits to return data for, should be facilities list and should not contain a region
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderSummaryGetOrderSummaryPrnOverSixtyDaysByPrescriber(orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public orderSummaryGetOrderSummaryPrnOverSixtyDaysByPrescriber(orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public orderSummaryGetOrderSummaryPrnOverSixtyDaysByPrescriber(orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public orderSummaryGetOrderSummaryPrnOverSixtyDaysByPrescriber(orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderSummaryGetOrderSummaryPrnOverSixtyDaysByPrescriber.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<AggregateData>>(`${this.basePath}/api/OrderSummary/GetOrderSummaryPrnOverSixtyDaysByPrescriber`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Percentage of PRn Orders
     * Percentage of total residents in the selected facilities against the number of residents on IV antibiotics in the selected date range     Sample Call      http://URL/api/OrderSummary/GetOrderSummaryPrnOverSixtyDaysPercentage?orgUnit&#x3D;10wilm
     * @param orgUnit List of Organizational Units to return data for, should be a list of facilities and should not contain a region
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderSummaryGetOrderSummaryPrnOverSixtyDaysPercentage(orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<ResidentCountResult>;
    public orderSummaryGetOrderSummaryPrnOverSixtyDaysPercentage(orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResidentCountResult>>;
    public orderSummaryGetOrderSummaryPrnOverSixtyDaysPercentage(orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResidentCountResult>>;
    public orderSummaryGetOrderSummaryPrnOverSixtyDaysPercentage(orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderSummaryGetOrderSummaryPrnOverSixtyDaysPercentage.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ResidentCountResult>(`${this.basePath}/api/OrderSummary/GetOrderSummaryPrnOverSixtyDaysPercentage`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Percent of Black Box data aggregated by drug group up to a maximum of 6 (including other)
     * Sample Call  http://URL/api/OrderSummary/GetPercentBlackBoxOrdersByDrugGroup?orgUnit&#x3D;10wilm
     * @param orgUnit Organizational Unit to return data for, should be a single facility and should not contain a region
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderSummaryGetPercentBlackBoxOrdersByDrugGroup(orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<ResidentCountResult>;
    public orderSummaryGetPercentBlackBoxOrdersByDrugGroup(orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResidentCountResult>>;
    public orderSummaryGetPercentBlackBoxOrdersByDrugGroup(orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResidentCountResult>>;
    public orderSummaryGetPercentBlackBoxOrdersByDrugGroup(orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderSummaryGetPercentBlackBoxOrdersByDrugGroup.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ResidentCountResult>(`${this.basePath}/api/OrderSummary/GetPercentBlackBoxOrdersByDrugGroup`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Raw data  (Grid Data).
     * This returns Medication Summary details.  Data in this call is not aggregated.                    Sample Call      http://URL/api/OrderSummary/GetPrnOrders?orgUnit&#x3D;10wilm
     * @param orgUnit Organizational Unit to return data for, should be a single facility and should not contain a region
     * @param sortFilterDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderSummaryGetPrnOrders(orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryOrderSummaryDetail>;
    public orderSummaryGetPrnOrders(orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryOrderSummaryDetail>>;
    public orderSummaryGetPrnOrders(orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryOrderSummaryDetail>>;
    public orderSummaryGetPrnOrders(orgUnit: string, sortFilterDto: SortFilterDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderSummaryGetPrnOrders.');
        }

        if (sortFilterDto === null || sortFilterDto === undefined) {
            throw new Error('Required parameter sortFilterDto was null or undefined when calling orderSummaryGetPrnOrders.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryOrderSummaryDetail>(`${this.basePath}/api/OrderSummary/GetPrnOrders`,
            sortFilterDto,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Percentage of residents with 20+ Medication grouped by order date month.
     * This should be used only when a single org unit is selected in the UI.  Results will be grouped by Order month and then within each group the percentage of resident is caculated                    Sample Call      http://URL/api/OrderSummary/GetResidentWith20OrMoreMedicationByMonth?orgUnit&#x3D;590
     * @param orgUnit Organizational Unit to return data for, should be a single facility and should not contain a region
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderSummaryGetResidentWith20OrMoreMedicationByMonth(orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public orderSummaryGetResidentWith20OrMoreMedicationByMonth(orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public orderSummaryGetResidentWith20OrMoreMedicationByMonth(orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public orderSummaryGetResidentWith20OrMoreMedicationByMonth(orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderSummaryGetResidentWith20OrMoreMedicationByMonth.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<AggregateData>>(`${this.basePath}/api/OrderSummary/GetResidentWith20OrMoreMedicationByMonth`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Percentage of residents with 20+ Medication grouped by prescriber.
     * This should be used only when a single org unit is selected in the UI.  Results will be grouped by Prescriber and then within each group the top 4 prescribers with the 5th being \&quot;Other if there are more than  5 unique prescribers                    Sample Call      http://URL/api/OrderSummary/GetResidentWith20OrMoreMedicationByPrescriber?orgUnit&#x3D;590
     * @param orgUnit Organizational Unit to return data for, should be a single facility and should not contain a region
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderSummaryGetResidentWith20OrMoreMedicationByPrescriber(orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public orderSummaryGetResidentWith20OrMoreMedicationByPrescriber(orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public orderSummaryGetResidentWith20OrMoreMedicationByPrescriber(orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public orderSummaryGetResidentWith20OrMoreMedicationByPrescriber(orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderSummaryGetResidentWith20OrMoreMedicationByPrescriber.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<AggregateData>>(`${this.basePath}/api/OrderSummary/GetResidentWith20OrMoreMedicationByPrescriber`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Percentage of residents on 20 Or more medications
     * Percentage of total residents in the selected facilities against the number of residents that have 20 or more number of medications                   Sample Call     http://URL/api/OrderSummary/GetResidentWith20OrMoreMedicationsPercentage?startDate&#x3D;2016-1-1T12:30:00&amp;amp;endDate&#x3D;2017-2-1T12:30:00&amp;amp;orgUnit&#x3D;10wilm
     * @param startDate Date to start searching for data from
     * @param endDate Stop Date
     * @param orgUnit Organizational Unit to return data for, should be one facility and should not contain a region
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderSummaryGetResidentWith20OrMoreMedicationsPercentage(startDate: string, endDate: string, orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<ResidentCountResult>;
    public orderSummaryGetResidentWith20OrMoreMedicationsPercentage(startDate: string, endDate: string, orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResidentCountResult>>;
    public orderSummaryGetResidentWith20OrMoreMedicationsPercentage(startDate: string, endDate: string, orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResidentCountResult>>;
    public orderSummaryGetResidentWith20OrMoreMedicationsPercentage(startDate: string, endDate: string, orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (startDate === null || startDate === undefined) {
            throw new Error('Required parameter startDate was null or undefined when calling orderSummaryGetResidentWith20OrMoreMedicationsPercentage.');
        }

        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling orderSummaryGetResidentWith20OrMoreMedicationsPercentage.');
        }

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderSummaryGetResidentWith20OrMoreMedicationsPercentage.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate);
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate);
        }
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ResidentCountResult>(`${this.basePath}/api/OrderSummary/GetResidentWith20OrMoreMedicationsPercentage`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Raw data  (Grid Data).
     * This returns Medication Summary details.  Data in this call is not aggregated.                    Sample Call      http://URL/api/OrderSummary/GetOrders?startDate&#x3D;2016-1-1T12:30:00&amp;amp;endDate&#x3D;2017-2-1T12:30:00&amp;amp;orgUnit&#x3D;10wilm
     * @param orgUnit Organizational Unit to return data for
     * @param sortFilterDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderSummaryGetResidentsOrders(orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryOrderSummaryDetail>;
    public orderSummaryGetResidentsOrders(orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryOrderSummaryDetail>>;
    public orderSummaryGetResidentsOrders(orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryOrderSummaryDetail>>;
    public orderSummaryGetResidentsOrders(orgUnit: string, sortFilterDto: SortFilterDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderSummaryGetResidentsOrders.');
        }

        if (sortFilterDto === null || sortFilterDto === undefined) {
            throw new Error('Required parameter sortFilterDto was null or undefined when calling orderSummaryGetResidentsOrders.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryOrderSummaryDetail>(`${this.basePath}/api/OrderSummary/GetOrders`,
            sortFilterDto,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Raw data for Residents with 20+ meds (Grid Data).
     * Data in this call is not aggregated.                    Sample Call      http://URL/api/OrderSummary/GetResidentsWith20OrMoreMedications?orgUnit&#x3D;10wilm
     * @param orgUnit Organizational Unit to return data for, should be a single facility and should not contain a region
     * @param sortFilterDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderSummaryGetResidentsWith20OrMoreMedications(orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryOrderSummaryDetail>;
    public orderSummaryGetResidentsWith20OrMoreMedications(orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryOrderSummaryDetail>>;
    public orderSummaryGetResidentsWith20OrMoreMedications(orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryOrderSummaryDetail>>;
    public orderSummaryGetResidentsWith20OrMoreMedications(orgUnit: string, sortFilterDto: SortFilterDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderSummaryGetResidentsWith20OrMoreMedications.');
        }

        if (sortFilterDto === null || sortFilterDto === undefined) {
            throw new Error('Required parameter sortFilterDto was null or undefined when calling orderSummaryGetResidentsWith20OrMoreMedications.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryOrderSummaryDetail>(`${this.basePath}/api/OrderSummary/GetResidentsWith20OrMoreMedications`,
            sortFilterDto,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Raw data  (Grid Data). Routine Orders
     * This returns Antibiotics.  Data in this call is not aggregated.                    Sample Call      http://URL/api/OrderSummary/GetRoutineOrders?startDate&#x3D;2016-1-1T12:30:00&amp;amp;endDate&#x3D;2017-2-1T12:30:00&amp;amp;orgUnit&#x3D;10wilm
     * @param orgUnit Organizational Unit to return data for, should be a single facility and should not contain a region
     * @param sortFilterDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderSummaryGetRoutineOrders(orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryOrderSummaryDetail>;
    public orderSummaryGetRoutineOrders(orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryOrderSummaryDetail>>;
    public orderSummaryGetRoutineOrders(orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryOrderSummaryDetail>>;
    public orderSummaryGetRoutineOrders(orgUnit: string, sortFilterDto: SortFilterDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderSummaryGetRoutineOrders.');
        }

        if (sortFilterDto === null || sortFilterDto === undefined) {
            throw new Error('Required parameter sortFilterDto was null or undefined when calling orderSummaryGetRoutineOrders.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryOrderSummaryDetail>(`${this.basePath}/api/OrderSummary/GetRoutineOrders`,
            sortFilterDto,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
